import { Navigate, Outlet } from 'react-router-dom';

type Props = {
  isAllowed: boolean;
  redirectPath?: string;
};

/**
 * Route with conditional access
 *
 * @param {boolean} isAllowed - displays content if true, else navigate to redirectPath
 * @param {string} redirectPath - the path to navigate to if not allowed (default is '/')
 * @returns ProtectedRoute
 */
export const ProtectedRoute = ({ isAllowed, redirectPath = '/' }: Props) => {
  return isAllowed ? <Outlet /> : <Navigate to={redirectPath} replace />;
};
